import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoadingService } from '@core/services/loading.service';
import { finalize } from 'rxjs';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  if (req.headers.has('lazyLoad')) return next(req);

  // Defer turning on the loader
  setTimeout(() => loadingService.incrementRequests(), 0);

  return next(req).pipe(
    finalize(() => {
      // Defer turning off the loader
      setTimeout(() => loadingService.decrementRequests(), 0);
    }),
  );
};
